<template>
  <div
    v-loading.fullscreen.lock="loading"
    class="BookIndex"
    :element-loading-text="false"
  >
    <div class="tabs clear">
      <a
        class="fl"
        :href="`/mall?city=${$route.query.city}`"
        target="_self"
      >{{ TLang('商城首页','my') }}</a>
      <img
        class="fl"
        :src="require('@assets/images/birthday/arrow.png')"
        alt=""
      />
      <span class="fl">{{ TLang('图书','my') }}</span>
    </div>
    <!-- <div :style="{ marginTop: unionFlag ? '20px' : '' }" class="advise-banner"> -->
    <div class="advise-banner">
      <LeftNavList
        v-if="catList.length"
        :catList="catList"
        :onChange="
          (id,item,type) => {
            toListPage(id,item,type);
          }
        "
      />
      <Carousel
        v-if="bannerImg.length > 0"
        :interval="3000"
        arrow="hover"
        height="455px"
      >
        <CarouselItem
          v-for="(item, index) in bannerImg"
          :key="index"
        >
          <a
            :href="
              unionFlag
                ? item.bfdUrl
                  ? item.bfdUrl
                  : 'javascript:void(0)'
                : item.adUrl
                  ? item.adUrl
                  : 'javascript:void(0)'
            "
            @click.prevent="clickCarousel(item)"
          >
            <img
              :src="item.adImg"
              alt
              :style="{ background: '#ccc' }"
            />
          </a>
        </CarouselItem>
      </Carousel>
    </div>

    <div class="goods-wrap">
      <ul ref="goodsWrap">
        <div v-if="hotList && hotList.length > 0">
          <li>
            <div>
              <div class="header-title">
                <div class="title-left">
                  <span>{{ TLang('热门推荐','my') }}</span>
                  <!-- <span class="en">Hot Recommend</span> -->
                </div>
                <div class="title-right">
                  <span>{{ currentIndex }}/{{ hotList.length }}</span>
                </div>
              </div>
              <div class="goodsList">
                <Carousel
                  v-if="hotList.length > 0"
                  ref="hotCarousel"
                  :interval="3000"
                  arrow="always"
                  indicator-position="none"
                  height="343px"
                  style="width: 100%"
                  @change="carouselChange"
                >
                  <CarouselItem
                    v-for="(list, index) in hotList"
                    :key="'hot' + index"
                  >
                    <div
                      v-for="(goods, i) in list"
                      :key="i"
                      class="item"
                    >
                      <!-- 将onClick传入组件item中 -->
                      <GoodsItem
                        v-if="goods"
                        :goods="goods"
                        :onClick="toDetailPage"
                        :onClickAdd="onClickAdd.bind(undefined, goods, 1)"
                        :purchaseType="goods.purchaseType"
                        :categoryName="TLang('热门推荐', 'my')"
                      />
                    </div>
                  </CarouselItem>
                </Carousel>
              </div>
            </div>
          </li>
        </div>
        <!-- 循环匹配 都按indexCategoryDtos 这个顺序显示 -->
        <div
          v-for="cate in indexCategoryDtos"
          :key="cate.id"
        >
          <li
            v-for="(item, index) in indexCategoryGoodsDtos"
            :key="index"
          >
            <div v-if="cate.id === item.categoryId">
              <div class="header-title">
                <div class="title-left">
                  <span>{{ item.categoryName }}</span>
                  <span class="en">{{ cate.enName }}</span>
                </div>
                <div
                  class="title-right"
                  @click="toListPage(item.categoryId,item)"
                >
                  <span>{{ TLang('查看更多','my') }}</span>
                  <i class="icon iconfont">&#xe657;</i>
                </div>
              </div>
              <div class="goodsList">
                <div
                  v-for="(goods, i) in item.indexSpuGoodsDtoList"
                  :key="i"
                  class="item"
                >
                  <GoodsItem
                    :goods="goods"
                    :onClick="toDetailPage"
                    :onClickAdd="onClickAdd.bind(undefined, goods, 2,item)"
                    :purchaseType="cate.purchaseType"
                    :categoryName="item.categoryName"
                  />
                </div>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <div
      v-if="isShowSticky && availWidth >= 1320"
      class="fixed-menu"
      :style="{
        left: fixedLeft + 'px',
        width: availWidth >= 1480 ? '140px' : '40px',
      }"
    >
      <div
        v-if="availWidth >= 1480"
        class="rich-screen"
      >
        <div
          v-for="(item, index) in indexCategoryDtos"
          :key="index"
          :class="{ fixedItem: true, active: index === activeFloor }"
          @click="scrollView(index,item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        v-else
        class="poor-screen"
      >
        <div
          v-for="(item, index) in indexCategoryDtos"
          :key="index"
          :class="{ fixedItem: true, active: index === activeFloor }"
          @click="scrollView(index,item)"
        >
          <span class="fixedItem-img">
            <img
              :src="item.imgUrl || require('../../assets/images/smallBell.png')"
              alt
            />
          </span>
          <span class="line-clamp-2">
            {{ item.name }}
          </span>
        </div>
      </div>
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="onCloseSkuModal"
      :onAdd="onClickSkuAdd"
    />
    <FixedButton :channelName="TLang('图书', 'my')" />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img :src="require('../../assets/images/cart_ok.png')" />
      <div class="title">
        {{ TLang('加入购物车成功','my') }}
      </div>
      <div
        v-if="chooseOfAdd.goodsName"
        class="goods-name"
      >
        {{ chooseOfAdd.goodsName }}
      </div>
      <div
        v-if="chooseOfAdd.specValue1 || chooseOfAdd.specName"
        class="goods-sku-name"
      >
        {{ TLang('规格','my') }}：{{ chooseOfAdd.specValue1 || chooseOfAdd.specName }}
      </div>
      <div class="btns">
        <button
          class="close-btn"
          @click="toDetail(chooseOfAdd)"
        >
          {{ TLang('查看商品详情','my') }}
        </button>
        <button
          class="buy-btn primary"
          @click="onClickGoBuy"
        >
          {{ TLang('去结算','my') }}
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import LeftNavList from "./LeftNavList";
import GoodsItem from "./GoodsItem";
import { CarouselItem, Carousel } from "element-ui";
import SkuPicker from "@components/SkuPicker";
import FixedButton from "@components/FixedButton";
import { Dialog } from "element-ui";
import {
  fetchLifeIndex,
  fetchProductListById,
  getBookAds,
  fetchGoodsTags,
} from "@fetch";
import { fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
// import Toast from '@components/simpleToast';
import Cookies from "js-cookie";
import { unionFlag,gioClickHandle } from "@utils";
import { dealTagGoods } from '@/utils/special';
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BookIndex",
  components: {
    LeftNavList,
    Carousel,
    CarouselItem,
    GoodsItem,
    // DefBody,
    SkuPicker,
    Dialog,
    FixedButton,
  },
  data() {
    return {
      loading: true,
      catList: [],
      hotList: [],
      bannerImg: [],
      indexCategoryGoodsDtos: [],
      indexCategoryDtos: [],
      activeFloor: 0,
      isShowSticky: false,
      availWidth: 100,
      scrollList: [],
      SkuPickerShow: false,
      activeGoods: {},
      chooseOfAdd: {},
      dialogVisible: false,
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
      fixedLeft: 0,
      unionFlag: unionFlag(),
      currentIndex: 1,
    };
  },
  computed: {
    ...mapGetters("shopCart", ["getCount"]),
    getGoodTagsParams() {
      const goodsList = [];
      this.indexCategoryGoodsDtos.forEach((item) => {
        item.indexSpuGoodsDtoList.forEach((good) => {
          if (item.categoryId)
            goodsList.push({
              categoryId: good.categoryId,
              goodsId: good.goodsId,
            });
        });
      });
      return goodsList;
    },
    getHotListTagsParams() {
      const goodsList = [];
      this.hotList.forEach((item) => {
        item.forEach((good) => {
          if (good.categoryId)
            goodsList.push({
              categoryId: good.categoryId,
              goodsId: good.goodsId,
            });
        });
      });
      return goodsList;
    },
  },
  created() {
    fetchLifeIndex({ channelId: "998" }).then((res) => {
      if (res) {
        this.loading = false;
        this.catList = res.indexCategoryDtos;
        this.bannerImg = res.advertisingWheelDtos;
        this.indexCategoryGoodsDtos = res.indexCategoryGoodsDtos;
        this.getGoodsTags(this.goodsListAddFlag);
        this.indexCategoryDtos = res.indexCategoryDtos;
        // 等待dom渲染完 拿到各楼层位置
        setTimeout(() => {
          this.handleScroll();
        }, 1000);
      }
    });
    // 热门推荐
    fetchProductListById({ channelId: 998, sortField: "5" }).then((res) => {
      this.hotList = [];
      if (res.categoryGoodsDtos && res.categoryGoodsDtos.categoryGoodsDtoList && res.categoryGoodsDtos.categoryGoodsDtoList.length > 0) {
        if (res.categoryGoodsDtos.categoryGoodsDtoList.length > 5) {
          let arr1 = [];
          let arr2 = [];
          res.categoryGoodsDtos.categoryGoodsDtoList.forEach((info, a) => {
            if (a < 5) {
              arr1.push(info);
            } else if (a >= 5 && a < 10) {
              arr2.push(info);
            }
          });
          this.hotList.push(arr1, arr2);
        } else {
          this.hotList.push(res.categoryGoodsDtos.categoryGoodsDtoList);
        }
      }
      // this.getGoodsTags(this.goodsHotListAddFlag);
      this.getHotListTags(this.goodsHotListAddFlag);
    });
    this.cartCount({ ...this.addressInfo });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.listenResize);
    this.availWidth =
      document.body.offsetWidth || document.documentElement.offsetWidth;
    this.computeLeft(this.availWidth >= 1480 ? 160 : 60);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.listenResize);
    this.$bus.$emit("onSticky", false);
  },

  methods: {
    ...mapActions("shopCart", ["cartCount"]),
    handleScroll() {
      // f滚动时，左侧菜单高亮
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let len = this.$refs.goodsWrap.children.length;
      this.scrollList = [];
      for (let i = 1; i < len; i++) {
        this.scrollList.push(this.$refs.goodsWrap.children[i].offsetTop - 120);
      }
      for (let j = 0; j < this.scrollList.length; j++) {
        if (
          scrollTop > this.scrollList[j] &&
          scrollTop <= this.scrollList[j + 1]
        ) {
          this.activeFloor = j;
          continue;
        }
        if (scrollTop >= this.scrollList[this.scrollList.length - 1]) {
          this.activeFloor = this.scrollList.length - 1;
        }
      }
      this.isShowSticky = scrollTop >= 80;
      this.$bus.$emit("onSticky", this.isShowSticky);
    },
    listenResize() {
      this.availWidth =
        document.body.offsetWidth || document.documentElement.offsetWidth;
      this.computeLeft(this.availWidth >= 1480 ? 160 : 60);
    },
    computeLeft(width) {
      this.fixedLeft = (this.availWidth - 1200) / 2 - width;
    },
    scrollView(i,item) {
      const params = {
        df_channle:'图书',
        df_pagename:'频道首页',
        df_modulename:'楼层',
        df_elementname:'分类导航',
        df_firstCategory:item.name,
        df_firstCategoryId:''+item.id,
      };
      gioClickHandle('DF_elementClick',params,'channelGio');
      // 由于增加了热门模块，i需加1
      this.$refs.goodsWrap.children[i + 1].scrollIntoView({
        behavior: "smooth",
      });
    },
    toListPage(cat,category,type) {
      const params = {
        df_channle:'图书',
        df_pagename:'频道首页',
        df_modulename:type ? '分类导航' : '楼层',
        df_elementname:type ? '一级分类' : '更多分类',
        df_firstCategory:type ? category.name :category.categoryName,
        df_firstCategoryId:''+(type ? category.name : category.categoryId),
      };
      gioClickHandle('DF_elementClick',params,'channelGio');
      this.$router.push(`product/list?categoryId=${cat}&channelId=998`);
    },
    toDetailPage(goods,categoryName) {
      let spuId = goods.mallSpuId || goods.spuId;
      const params = {
        df_channle:'图书',
        df_pagename:'频道首页',
        df_modulename:categoryName == '热门推荐'?'热门推荐':'楼层',
        df_elementname:'商品详情',
        df_firstCategory:categoryName,
        df_goodsname:goods.goodsName,
        df_spu_code:''+ spuId,
      };
      gioClickHandle('DF_elementClick',params,'channelGio');
      if (goods.goodsType === 0) {
        window.df_sdk_common.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
      } else if (goods.goodsType === 1) {
        let url = `/birthday/goods/detail/${goods.spuId}?city=${
          this.addressInfo.cityId || 145
        }`;
        if (goods.pcUrl){
          url = goods.pcUrl;
        }
        window.df_sdk_common.location.href = url;
      }
    },
    onCloseSkuModal() {
      this.SkuPickerShow = false;
    },
    onClickAdd(goods, num,category = {}) {
      // 1 热门推荐 2 常规分类
      let spuId = num == 1 ? goods.mallSpuId : goods.spuId;
      const params = {
        df_channle:'图书',
        df_pagename:'频道首页',
        df_modulename:num == 1?'热门推荐':'楼层',
        df_elementname:'加购',
        df_firstCategory:num == 1?'热门推荐':category.categoryName,
        df_goodsname:goods.goodsName,
        df_spu_code:''+ spuId,
      };
      gioClickHandle('DF_elementClick',params,'channelGio');
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: spuId,
      }).then((body) => {
        if (body) {
          // 单规格
          if (body.length === 1) {
            const myChoose = {
              categoryId: body[0].categoryId,
              goodsId: body[0].goodsId,
              num: body[0].buyMin || 1,
            };
            this.onClickSkuAdd(myChoose);
            return;
          }
          try {
            let checkList = [];
            body && body.length > 0 && body.forEach(item => {
              item.tags = [];
              if (item.categoryId && item.goodsId) {
                checkList.push({
                  categoryId: item.categoryId,
                  goodsId: item.goodsId,
                });
              }
            });
            checkList && checkList.length > 0 && getActivityTag({
              channel: 2,
              goodsList: checkList,
            }).then((res) => {
              if (res && res.length > 0){
                body && body.length > 0 && body.forEach(item => {
                  item = dealTagGoods(item, res);
                });
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              } else {
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              }
            });
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
          }
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
    },
    onClickSkuAdd(myChoose) {
      this.chooseOfAdd = myChoose;
      fetchaddCart({
        categoryId: myChoose.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body) {
          this.dialogVisible = true;
          this.cartCount({ ...this.addressInfo });
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
      this.onCloseSkuModal();
    },
    // 加入购物车成功后 去商品详情页
    toDetail(goods) {

      window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`, this.isFeishuOrDingding ? '_self' : '_blank');
    },
    onClickGoBuy() {
      window.df_sdk_common.location.href = "/shop/shopping/cart";
    },
    carouselChange: function(key1, key2) {
      //目前激活的幻灯片的索引和原幻灯片的索引
      // console.log(key1 + ",,,," + key2);
      this.currentIndex = Number(key1) + 1;
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.indexCategoryGoodsDtos.forEach((item) => {
        item.indexSpuGoodsDtoList.forEach((good) => {
          const goodTag = res.find(
            (tag) =>
              tag.categoryId == good.categoryId && tag.goodsId == good.goodsId,
          ) || {};
          let tags = goodTag && goodTag.tags ? goodTag.tags : [];
          // 图书标签
          // let newTags = tags.filter((item) => item.type === 1 || item.type === 3 );
          //type  1特价抢购   满减     2爆炸贴       3新品
          let newTags = tags.filter((item) => item.type != 2 );
          let stickerImgList = tags.filter((item) => item.type === 2);
          const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
          const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
          const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
          this.$set(good, "tags", newTags);
          this.$set(good, "promPrice", promPrice);
          this.$set(good, "salePrice", salePrice);
          this.$set(good, "bizStock", bizStock);
          // 爆炸贴数据
          this.$set(good, "stickerImgList", stickerImgList);
          // 拼接折扣信息
          this.$set(good, "discount", goodTag.discount);
          this.$set(good, "discountPrice", goodTag.discountPrice);
          this.$set(good, "discountTagShow", goodTag.discountTagShow);
          this.$set(good, "mktTagShow", goodTag.mktTagShow);
        });
      });
    },
    // HotList数据拼接tag
    goodsHotListAddFlag(res) {
      this.hotList.forEach((item) => {
        item.forEach((good) => {
          const goodTag = res.find(
            (tag) =>
              tag.categoryId == good.categoryId && tag.goodsId == good.goodsId,
          ) || {};
          let tags = goodTag && goodTag.tags ? goodTag.tags : [];
          let newTags = tags.filter((item) => item.type != 2);
          let stickerImgList = tags.filter((item) => item.type === 2);
          const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
          const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
          const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
          this.$set(good, "tags", newTags);
          this.$set(good, "promPrice", promPrice);
          this.$set(good, "salePrice", salePrice);
          this.$set(good, "bizStock", bizStock);
          // 爆炸贴数据
          this.$set(good, "stickerImgList", stickerImgList);
          // 拼接折扣信息
          this.$set(good, "discount", goodTag.discount);
          this.$set(good, "discountPrice", goodTag.discountPrice);
          this.$set(good, "discountTagShow", goodTag.discountTagShow);
          this.$set(good, "mktTagShow", goodTag.mktTagShow);
        });
      });
    },
    // 获取商品tag
    getGoodsTags(cbk) {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              cbk.call(this, res);
            }
          },
        );
      }
    },
    // 获取热门列表tag信息
    getHotListTags(cbk) {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              cbk.call(this, res);
            }
          },
        );
      }
    },
    // 点击轮播图
    clickCarousel(item){
      const params = {
        df_channle:'图书',
        df_pagename:'频道首页',
        df_modulename:'轮播',
        df_elementname:''+item.id,
      };
      gioClickHandle('DF_elementClick',params,'channelGio');
      window.df_sdk_common.location.href = this.unionFlag ? item.bfdUrl ? item.bfdUrl : 'javascript:void(0)' : item.adUrl ? item.adUrl : 'javascript:void(0)';
    },
  },
};
</script>

<style lang="less">
.BookIndex {
  .tabs {
    font-size: 14px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    a {
      color: #666;
      text-align: center;
      line-height: 28px;
      border-radius: 5px;
    }
    img {
      width: 16px;
      height: 16px;
      margin: auto 5px;
    }
    span {
      line-height: 30px;
      color: #666;
      text-align: center;
      border-radius: 5px;
    }
  }
  .advise-banner {
    display: flex;
    padding-top: 44px;
    overflow-y: hidden;
    margin-left: -20px;
    /deep/ .cat-list {
      width: 220px;
      margin-top: -44px;
    }
    .el-carousel {
      flex: 1;
      .el-carousel__container {
        a {
          display: inline-block;
          width: 100%;
          img {
            width: 1200px;
            height: 450px;
          }
        }
        .el-carousel__arrow {
          width: 50px !important;
          height: 100px !important;
          border-radius: 0;
          i {
            font-size: 35px;
            color: #ededed;
            opacity: 0.9;
          }
        }
        .el-carousel__arrow--left {
          left: 0;
        }
        .el-carousel__arrow--right {
          right: 0;
        }
      }
      .el-carousel__indicators {
        .el-carousel__button {
          width: 10px;
          height: 10px;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
        }
      }
    }
  }
  .goods-wrap {
    padding-top: 30px;
    ul {
      li {
        margin-bottom: 60px;
        .header-title {
          display: flex;
          justify-content: space-between;
          padding-bottom: 10px;
          border-bottom: 1px solid #f0f0f0;
          align-items: baseline;
          padding-top: 140px;
          margin-top: -140px;
          .title-left {
            font-size: 24px;
            color: rgba(51, 51, 51, 1);
            // margin-left: 20px;
            .en {
              font-size: 14px;
              color: rgba(204, 204, 204, 1);
            }
          }
          .title-right {
            display: flex;
            align-items: center;
            .icon {
              transform: rotate(90deg);
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
        .goodsList {
          display: flex;
          flex-wrap: wrap;
          .el-carousel {
            .item {
              &:hover {
                box-shadow: none;
              }
            }
          }
          .el-carousel__arrow {
            width: 40px !important;
            height: 40px !important;
            border-radius: 0;
            background-color: rgba(0, 0, 0, 0.2);
            opacity: 0;
            i {
              font-size: 16px;
              color: #fff;
              opacity: 0.6;
            }
            &:hover {
              background-color: rgba(0, 0, 0, 0.2);
            }
          }
          .el-carousel__arrow--left {
            left: -11px;
            border-radius: 0 20px 20px 0;
          }
          .el-carousel__arrow--right {
            right: -11px;
            border-radius: 20px 0 0 20px;
          }
          .el-carousel__item {
            display: flex;
            flex-wrap: wrap;
          }
          .item {
            margin-right: 12px;
            padding: 15px 0;
            margin-top: 10px;
            &:hover {
              box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.05);
            }
          }
          .item:nth-child(5n) {
            margin-right: 0;
          }
          &:hover {
            .el-carousel__arrow {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .fixed-menu {
    position: fixed;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    top: 100px;
    left: 20px;
    width: 140px;
    text-align: center;
    z-index: 1000;
    .rich-screen {
      width: 140px;
      max-height: 70vh;
      overflow-y: scroll;
    }
    .poor-screen {
      width: 40px;
      .fixedItem {
        width: 40px;
        height: 40px;
        line-height: 14px;
        word-break: break-all;
        position: relative;
        img {
          width: 60%;
          height: 60%;
          vertical-align: top;
        }
        .line-clamp-2 {
          display: none;
          position: absolute;
          top: 4px;
          right: 4px;
          bottom: 4px;
          left: 4px;
          color: #3d96e2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 16px;
        }
        &:hover img {
          display: none;
        }
        &:hover .line-clamp-2 {
          display: -webkit-box;
        }
        &:hover {
          background: #fff;
        }
        &.active:hover {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          color: #fff;
        }
      }
    }
    .fixedItem {
      font-size: 12px;
      color: #222;
      line-height: 32px;
      text-align: center;
      &-img {
        display: table-cell;
        vertical-align: middle;
        width: 40px;
        height: 40px;
      }
    }
    .fixedItem.active {
      color: #fff;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      img {
        display: none;
      }
      .line-clamp-2 {
        display: -webkit-box;
        color: #fff;
      }
    }
    .fixedItem:hover {
      color: #fff;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      cursor: pointer;
    }
  }
  .header-body-sticky {
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 999;
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.05);
  }
  /deep/ .product-dialog {
    .title {
      margin-top: 18px;
    }
    .goods-name {
      color: #7f7f7f;
      margin-top: 18px;
    }
    .goods-sku-name {
      color: #b2b2b2;
      margin-top: 5px;
    }
  }
}
</style>
